import { initModal } from "./modules/modal";
import { syncModalOpenButtonTop } from "./modules/modalOpenButton";
import { initStickyAside } from "./modules/stickyAside";
import { initEntryForm } from "./modules/entryForm";
import { initScroll } from "./modules/scroll";
import { initSmoothScroll } from "./modules/smoothScroll";
import { initSlider } from "./modules/slider";
import { initOpeningAnimation } from "./modules/openingAnimation";

document.addEventListener("DOMContentLoaded", () => {
  // 初期化
  initOpeningAnimation();
  initModal();
  syncModalOpenButtonTop();
  initStickyAside();
  initEntryForm();
  initScroll();
  initSmoothScroll();
  initSlider();
});
